import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { reaction } from 'mobx';
import b from 'b_';
import EnvStore from '../../../stores/EnvStore';
import { ModalMode } from '../../../stores/Policy/PolicyModalStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import FuseReadOnlySwitch from '../../FuseControls/FuseReadOnlySwitch';
import FuseReadOnlyTextfield from '../../FuseControls/FuseReadOnlyTextfield';
import PolicyModal from '../PolicyModal';
import PolicyModalHeaderLayout from '../PolicyModalHeaderLayout';
import RedirectMatchCriteria from './RedirectMatchCriteria';
import RedirectRulesOptions from './RedirectRulesOptions';
import ConsoleStore from '../../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import FuseConsoleCardFooter from '../../ConsoleFragments/FuseConsoleCardFooter';
import { Card, FTBody } from '../../Fuse';
import { ConsoleBody } from '../../Text/Text';
import FuseAlert from '../../FuseControls/FuseAlert';
import { POLICY_MIGRATION_STEP_ENUM } from '../../../constants';
import './RedirectRulesModal.css';

const block = b.lock('RedirectRulesModal');

class RedirectRulesModal extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        policy: PolicyStore.PropType.isRequired,
        env: EnvStore.PropType.isRequired,
    };
    setAlertFlags = async () => {
        const { policy, console } = this.props;
        if (console.policyMigrationStep === POLICY_MIGRATION_STEP_ENUM.NEW_IN_TEST
            && (policy.redirectRules.policyTable.policyModal.mode === ModalMode.CREATE ||
            policy.redirectRules.policyTable.policyModal.mode === ModalMode.EDIT)) {
            await policy.browsingRoles.policyTable.load();
            let showReminder = false;
            showReminder = policy.browsingRoles.policyTable.items.some((item) => {
                return item.status === 'ENABLED';
            });
            policy.redirectRules.showReminderAlert.setValue(showReminder);
            policy.redirectRules.showNoBrowsingRoleEnabledAlert.setValue(!showReminder);
        }
    }
    componentDidMount() {
        const { policy } = this.props;
        reaction(() => policy.redirectRules.policyTable.policyModal.mode,
            () => this.setAlertFlags()
        );
    }


    renderHeader = () => {
        const { env, policy } = this.props;
        const { policyModal } = policy.redirectRules.policyTable;
        const store = policyModal.header;
        const readOnly = policyModal.mode === ModalMode.VIEW || policyModal.mode === ModalMode.DELETE;
        const showWarning = policy.redirectRules.showNoBrowsingRoleEnabledAlert.getValue();

        return <PolicyModalHeaderLayout
            title="Summary"
            readOnly={readOnly}
            alert={showWarning
                ? <FuseAlert
                    type="danger"
                    title="WARNING: No Browsing Roles detected for step 2 of the new policy migration"
                    icon="info"
                    className={block('WarningAlert')}
                    style={{ marginBottom: 20 }}
                >
                    <FTBody >
                        You must have an <b>enabled Browsing Role</b> for
                        the users that will match this Redirect Rule before
                        it can be configured. Once redirected to Isolation, the
                        users selected below will be matched with the Browsing Role.
                    </FTBody>
                </FuseAlert>
                : null}
        >
            <FuseReadOnlyTextfield
                label="Name"
                store={store.name}
                placeholder="Enter Redirect Rule name"
                error={!store.name.isValid && store.name.isTouched}
                onBlur={store.onNameFieldFocusChange}
                showRequired={!readOnly}
                required={showWarning ? false : !readOnly}
                qa="entity-name"
                disabled={showWarning}
            />

            <FuseReadOnlyTextfield
                label="Description"
                store={store.description}
                readOnlyValue={store.description.value && store.description.value.trim() || '—'}
                placeholder="Enter Redirect Rule description"
                qa="entity-description"
                disabled={showWarning}
            />

            <FuseReadOnlySwitch
                header="Rule Status"
                tooltip="The status will determine if the Rule is available to live users or not"
                tooltipProps={env.screen.isMobile || readOnly ? { position: 'right' } : {}}
                store={store.status}
                label={store.status.isTrue ? 'Enabled' : 'Disabled'}
                qa="status-switch"
                disabled={showWarning}
            />
        </PolicyModalHeaderLayout>;
    };

    render() {
        const { console, policy } = this.props;
        const { policyModal } = policy.redirectRules.policyTable;
        const { options, matchCriteria } = policyModal.sections;
        const readOnly = [ModalMode.VIEW, ModalMode.DELETE].indexOf(policyModal.mode) > -1 ||
            console.authority === ROLE_READ_ONLY.value;

        return <PolicyModal
            titleItemName="Redirect Rule"
            itemName="Redirect Rule"
            store={policyModal}
            readOnly={console.authority === ROLE_READ_ONLY.value}
        >
            {this.renderHeader()}
            <RedirectRulesOptions store={options} readOnly={readOnly} />
            <RedirectMatchCriteria store={matchCriteria} readOnly={readOnly} />

            <Card title="Action">
                <ConsoleBody className={block('ActionText')}>
                    Redirect - Send matching URLs to open in the URL Isolation browser
                </ConsoleBody>
                <FuseConsoleCardFooter
                    text={'Only applies to the initial click on a rewritten TAP URL Defense link.'}
                />
            </Card>
        </PolicyModal>;
    }
}

export default inject('env', 'console', 'policy')(observer(RedirectRulesModal));
